import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'underscore';

import { dismissNotification } from '../../actions/userActions';

// SASS Imports
require('./NotificationBar.scss');

let mapStateToProps = (state, ownProps) => {
    return{
        user: state.user,
        settings: state.settings,
        notifications: state.notifications
    };
};
let mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dismissNotification: () => {
            dispatch(dismissNotification());
        },
    };
};
class NotificationBar extends Component {
    constructor(props) {
        super(props);
        this.dismissNotification = this.dismissNotification.bind(this);
    }
    dismissNotification(e) {
        // Dismiss on anchor only
        if(e.tagName.toUpperCase() === 'A') {
            this.props.dismissNotification();
        }
    }
	render() {
        let NextNotification = _.first(this.props.notifications.pending);
		return (
			<section className={ NextNotification ? "row notification" : "hidden"}>
				{NextNotification && this.props.settings.notifications && <div className="col-lg-6 col-lg-offset-3 col-xs-12 notificationContent">
                    <div className="col-xs-2 col-sm-2 col-sm-offset-2 col-md-2 col-md-offset-2">
                        <img src={require('./assets/warning.png')} alt="Un-submitted entry warning img-responsive" />
                    </div>
                    <div className="notificationText col-xs-10 col-sm-8 col-md-8">
						<h4>Notification</h4>
						<p onClick={(e) => this.dismissNotification(e.target) }>{NextNotification}</p>
					</div>
				</div>}
			</section>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationBar);



// WEBPACK FOOTER //
// ./app/components/NotificationBar/NotificationBar.jsx